const fmt = require("indian-number-format");

export default function Total({ totalSummary, userType }) {
  const booked = totalSummary?.booked || 0;
  const self = totalSummary?.self || 0;
  const lower = totalSummary?.lower || 0;
  const selfLive = totalSummary?.selfLive || 0;
  const lowerLive = totalSummary?.lowerLive || 0;
  const total = totalSummary?.total || 0;
  const net_total = totalSummary?.net_total || 0;

  // ⭐ Helper for conditional CSS classes
  const cls = (...names) => {
    return userType === 1 ? [...names, "small"].join(" ") : names.join(" ");
  };

  return (
    <div className="menuContainer NetTotalCard">
      <div className={cls("menuUsername", "primarytext")}>TOTAL</div>

      <div className={cls("menuUsername", booked > 0 ? "buytext" : "selltext")}>
        {fmt.format(booked)}
      </div>

      <div className={cls("menuName", total > 0 ? "buytext" : "selltext")}>
        {fmt.format(total)}
      </div>
      <div className={cls("menuName", net_total > 0 ? "buytext" : "selltext")}>
        {fmt.format(net_total)}
      </div>

      <div className={cls("menuName", self > 0 ? "buytext" : "selltext")}>
        {fmt.format(self)}
      </div>

      <div className={cls("menuName", lower > 0 ? "buytext" : "selltext")}>
        {fmt.format(lower)}
      </div>

      <div className={cls("menuName", selfLive > 0 ? "buytext" : "selltext")}>
        {fmt.format(selfLive)}
      </div>

      <div className={cls("menuName", lowerLive > 0 ? "buytext" : "selltext")}>
        {fmt.format(lowerLive)}
      </div>
    </div>
  );
}
